export const GlazingSvg = () => (
  <svg
    fill="none"
    height="200"
    viewBox="0 0 400 200"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect fill="white" height="200" width="400" />
    <path
      d="M140 40.9998L136 39V145L140 147V40.9998Z"
      fill="#EEE8E1"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <path
      d="M196 19L136 39L140 41L200 21L196 19Z"
      fill="#EEE8E1"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <path
      d="M200 21L140 41V147L200 127V21Z"
      fill="#EEE8E1"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <path
      d="M156 49.4998L152 47.5V153.5L156 155.5V49.4998Z"
      fill="white"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <path
      d="M212 27.5L152 47.5L156 49.5L216 29.5L212 27.5Z"
      fill="white"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <path
      d="M216 29.5L156 49.5V155.5L216 135.5V29.5Z"
      fill="white"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <path
      d="M232 38L172 58V164L232 144V38Z"
      fill="white"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <path d="M220 56L184 68V146L220 134V56Z" fill="url(#pattern0)" />
    <path
      d="M236 64.5L232 62.5V140.5L236 142.5V64.5Z"
      fill="white"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <path
      d="M232 140.5L196 152.5L200 154.5L236 142.5L232 140.5Z"
      fill="white"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <path
      d="M188 66.4998L184 64.5V170.5L188 172.5V66.4998Z"
      fill="white"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <path
      d="M244 44.5L184 64.5L188 66.5L248 46.5L244 44.5Z"
      fill="white"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M188 66.5L248 46.5V152.5L188 172.5V66.5ZM200 76.5L236 64.5V142.5L200 154.5V76.5Z"
      fill="white"
      fillRule="evenodd"
    />
    <path
      d="M248 46.5H248.5C248.5 46.3393 248.423 46.1884 248.292 46.0944C248.162 46.0004 247.994 45.9748 247.842 46.0257L248 46.5ZM188 66.5L187.842 66.0257C187.638 66.0937 187.5 66.2848 187.5 66.5H188ZM248 152.5L248.158 152.974C248.362 152.906 248.5 152.715 248.5 152.5H248ZM188 172.5H187.5C187.5 172.661 187.577 172.812 187.708 172.906C187.838 173 188.006 173.025 188.158 172.974L188 172.5ZM236 64.5H236.5C236.5 64.3393 236.423 64.1884 236.292 64.0944C236.162 64.0004 235.994 63.9748 235.842 64.0257L236 64.5ZM200 76.5L199.842 76.0257C199.638 76.0937 199.5 76.2848 199.5 76.5H200ZM236 142.5L236.158 142.974C236.362 142.906 236.5 142.715 236.5 142.5H236ZM200 154.5H199.5C199.5 154.661 199.577 154.812 199.708 154.906C199.838 155 200.006 155.025 200.158 154.974L200 154.5ZM247.842 46.0257L187.842 66.0257L188.158 66.9743L248.158 46.9743L247.842 46.0257ZM248.5 152.5V46.5H247.5V152.5H248.5ZM188.158 172.974L248.158 152.974L247.842 152.026L187.842 172.026L188.158 172.974ZM187.5 66.5V172.5H188.5V66.5H187.5ZM235.842 64.0257L199.842 76.0257L200.158 76.9743L236.158 64.9743L235.842 64.0257ZM236.5 142.5V64.5H235.5V142.5H236.5ZM200.158 154.974L236.158 142.974L235.842 142.026L199.842 154.026L200.158 154.974ZM199.5 76.5V154.5H200.5V76.5H199.5Z"
      fill="#2B2011"
    />
    <path
      d="M264 54.9998L260 53V159L264 161V54.9998Z"
      fill="#F3FBFF"
      fillOpacity="0.6"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <path
      d="M260 159L200 179L204 181L264 161L260 159Z"
      fill="#F3FBFF"
      fillOpacity="0.6"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <path
      d="M204 74.9998L200 73V179L204 181V74.9998Z"
      fill="#F3FBFF"
      fillOpacity="0.6"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <path
      d="M260 53L200 73L204 75L264 55L260 53Z"
      fill="#F3FBFF"
      fillOpacity="0.6"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <path d="M264 55L204 75V181L264 161V55Z" fill="white" fillOpacity="0.6" />
    <path
      d="M264 55L204 75V181L264 161V55Z"
      fill="url(#paint0_linear_5342_5570)"
    />
    <path
      d="M264 55L204 75V181L264 161V55Z"
      stroke="#2B2011"
      strokeLinejoin="round"
    />
    <defs>
      <pattern
        height="1"
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
      >
        <use
          transform="matrix(0.0016756 0 0 0.000670241 -0.438338 0)"
          xlinkHref="#image0_5342_5570"
        />
      </pattern>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_5342_5570"
        x1="234"
        x2="234"
        y1="55"
        y2="181"
      >
        <stop stopColor="#F3FBFF" />
        <stop offset="0.473958" stopColor="#F3FBFF" stopOpacity="0" />
        <stop offset="1" stopColor="#F3FBFF" />
      </linearGradient>
    </defs>
  </svg>
);
